import { render, staticRenderFns } from "./LastPriceUpdated.vue?vue&type=template&id=3fe93006&scoped=true"
import script from "./LastPriceUpdated.vue?vue&type=script&lang=ts"
export * from "./LastPriceUpdated.vue?vue&type=script&lang=ts"
import style0 from "./LastPriceUpdated.vue?vue&type=style&index=0&id=3fe93006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe93006",
  null
  
)

export default component.exports